export default "__VITE_ASSET__BbzFd7w5__"